










import Vue from 'vue'
import store from '@/store'
const menuList = [
  {
    name: '本地天气',
    path: '/current_weather',
  },
  {
    name: '气象证明',
    path: '/weather_certificate',
  },
  {
    name: '同州天气',
    path: '/current_forecast',
  },
  {
    name: '气温监测',
    path: '/weather_monitor/tem',
  },
  {
    name: '降水监测',
    path: '/weather_monitor/pre',
  },
  {
    name: '风速风向',
    path: '/weather_monitor/wind',
  },
  {
    name: '相对湿度',
    path: '/weather_monitor/rhu',
  },
  {
    name: '预警列表',
    path: '/warn_category_list'
  },
  {
    name: '三天预报',
    path: '/daily_forecast',
  },
  {
    name: '一周预报',
    path: '/weekly_forecast',
  },
  {
    name: '十五天预报',
    path: '/daily15_forecast',
  },
  {
    name: '专题产品',
    path: '/subject_list?id=4',
  }, 
  {
    name: '气象动态',
    path: '/subject_list?id=5',
  },
    {
    name: '气象科普',
    path: '/subject_list?id=6',
  },
  {
    name: '防灾减灾',
    path: '/subject_list?id=7',
  },
  {
    name: '冬枣气象服务',
    path: '/services/jujube_service',
  },





  // {
  //   name: '信息反馈',
  //   path: '/info_feedback',
  // },
  // {
  //   name: '我的定制',
  //   path: '/custom_message',
  // },
  // {
  //   name: '角色申请',
  //   path: '/apply_role',
  // },
  // {
  //   name: '消息列表',
  //   path: '/msg_list',
  // },
  // {
  //   name: '气象知识',
  //   path: '/meteo_knowledge',
  // },
]
export default Vue.extend({
  data() {
    return {
      menuList,
    }
  },
  created() {
    // 水库员
    // const token = 'eyJhbGciOiJIUzUxMiJ9.eyJyYW5kb21LZXkiOiI3bDQ4bW8iLCJzdWIiOiJoNSYmJjY1MGY3Y2MzODljYTRjNjI5ODhkZTg4YjU5ZGNiZjM5IiwiZXhwIjoxNjQwMjI0OTQwLCJpYXQiOjE2Mzk2MjAxNDB9.BL9BOquemtSHhSSXaivIbRQ2WLSi-KH1TvufOZ3CAaj0W5Ju1UQZ9-dZ1eyXJdARz1ZAasBwc5lBf_Tipq1VOA'
    // 信息员
    // const token = 'eyJhbGciOiJIUzUxMiJ9.eyJyYW5kb21LZXkiOiJlaHkzb3YiLCJzdWIiOiJoNSYmJjY1MGY3Y2MzODljYTRjNjI5ODhkZTg4YjU5ZGNiZjM5IiwiZXhwIjoxNjUxMTk2NzcyLCJpYXQiOjE2NTA1OTE5NzJ9.Md4bK9NysDKrE7l6zzgrZdM9dIGT9xZ96v2zWOMa6BwQouDEtwo3wyuUWHG9HtNX5oTOj7wr8JIpjrAOGNpvag'
    // store.commit('login', token )
  },
})
